import { initializeApp, getApps, getApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getAnalytics, isSupported } from "firebase/analytics";
import { getPerformance } from "firebase/performance";

const firebaseConfig = {
  apiKey: "AIzaSyDwpUekvnYsr5qdj2BZPQs_teuukcKoV50",
  authDomain: "its-your-story.firebaseapp.com",
  projectId: "its-your-story",
  storageBucket: "its-your-story.appspot.com",
  messagingSenderId: "905651157300",
  appId: "1:905651157300:web:10d9d77f6a6a65874f8d61",
  measurementId: "G-L4SXJR7YB0",
};

const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const db = getFirestore(app);
export const storage = getStorage(app);

// Initialize Analytics only in browser environment
let analytics: ReturnType<typeof getAnalytics> | null = null;
isSupported().then((supported) => {
  if (supported) {
    analytics = getAnalytics(app);
  }
});

// Initialize Performance Monitoring only in browser environment
let perf: ReturnType<typeof getPerformance> | null = null;
if (typeof window !== "undefined") {
  try {
    perf = getPerformance(app);
  } catch {
    perf = null;
  }
}

export { analytics, perf };

const firebaseServices = {
  auth,
  googleProvider,
  db,
  storage,
  analytics,
  perf,
};

export default firebaseServices;
